<template>
    <div class="form-reset">
        <div class="form-reset__header">
            Сброс пароля
        </div>
        <div class="form-reset__body" v-if="active_form === 0">
            <div class="form-reset__title">Введите E-mail на который был зарегистрирован аккаунт</div>
            <div class="form-reset__email">
                <ValidationProvider immediate rules="required" v-slot="{ errors }" >
                    <input type="email" placeholder="E-mail" v-model="email">
                    <span class="input-error">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="form-reset__controls">
                <div class="form-reset__button" @click="active_form = 1">Отправить код подтверждения</div>
                <div class="form-reset__addition" @click="backSignIn()">
                    <span class="prev">
                        <arrow-left-icon size="1x" class="custom-class"></arrow-left-icon>
                    </span>
                    Назад к входу</div>
            </div>
        </div>
        <div class="form-reset__body" v-else-if="active_form === 1">
            <div class="form-reset__title">Введите полученный код на lorem_ipsun23@gmail.com</div>
            <div class="form-reset__content">
                <div class="form-reset__input-block">
                    <ValidationObserver tag="form" rules="required|numeric" v-slot="{ errors }" >
                        <input type="text" maxlength="1" @keyup="next($event, 'val1')" v-model="test_code.val1">
                        <input type="text" maxlength="1" @keyup="next($event, 'val2')" v-model="test_code.val2">
                        <input type="text" maxlength="1" @keyup="next($event, 'val3')" v-model="test_code.val3">
                        <input type="text" maxlength="1" @keyup="next($event, 'val4')" v-model="test_code.val4">
                        <input type="text" maxlength="1" @keyup="next($event, 'val5')" v-model="test_code.val5">
                        <input type="text" maxlength="1" v-model="test_code.val6">
                        <span class="input-error">{{ errors[0] }}</span>
                    </ValidationObserver>
                </div>
            </div>
            <div class="form-reset__controls">
                <div class="form-reset__button" @click="active_form = 2">Подтвердить</div>
                <div class="form-reset__controls-additions">
                    <div class="form-reset__addition" @click="active_form = 0">
                        <span class="prev">
                            <arrow-left-icon size="1x" class="custom-class"></arrow-left-icon>
                        </span>
                        Назад</div>
                    <div class="form-reset__addition">Отправить код повторно</div>
                </div>
            </div>
        </div>
        <div class="form-reset__body" v-else>
            <div class="form-reset__password">
                <ValidationProvider vid="newPassword" v-slot="{ errors }">
                    <input type="text" v-model="newPassword" placeholder="Новый пароль">
                    <span class="input-error">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider rules="confirmed:newPassword" v-slot="{ errors }">
                    <input type="text" v-model="newPasswordConfirm" placeholder="Повторите пароль">
                    <span class="input-error">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="form-reset__controls">
                <div class="form-reset__button" @click="close()">Подтвердить</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ArrowLeftIcon } from 'vue-feather-icons';

    export default {
        name: "PasswordReset",
        components: { ArrowLeftIcon },
        data() {
            return {
                newPassword: '',
                newPasswordConfirm: '',
                active_form: 0,
                email: '',
                test_code: {
                    val1: null,
                    val2: null,
                    val3: null,
                    val4: null,
                    val5: null,
                    val6: null,
                }
            }
        },
        methods: {
            backSignIn() {
                this.$emit('openSignIn')
            },
            close() {
                this.$emit('close')
            },
            next(e, val) {
                if(this.test_code[`${val}`].length === 1) e.target.nextElementSibling.focus()
            }
        },
//        watch: {
//            test_code: {
//                deep: true,
//                handler(val) {
////                    let rgx = new RegExp(/[^абвгдеєїіжзийклмнопрстуфхцчшщьҐґюяАБВГДЕЖЗИЙКЛМНОПРСТУФХІЇЦЧШЩЬЮЯ'’.,`\- 0-9\s]/g);
////                    this.group_name = val.replace(rgx, '');
//                    Object.keys(val).map(item => String(val[item]).length > 1 ? val[item].nextElementSibling.focus() : '')
////                    val.map(item => String(val.item).length > 1 ? val.item.target.nextElementSibling.focus() : '' )
//                }
//            }
//        }
    }
</script>

<style scoped lang="scss">
    .form-reset {
        &__header {
            background: linear-gradient(65.4deg, #6BBCBA 0%, #3BA5A1 100%);
            border-radius: 7px 7px 0px 0px;
            color: #FCFCFC;
            font-size: 16px;
            line-height: 25px;
            padding: 16px 20px;
            text-align: center;
        }
        &__body {
            padding: 24px 24px 32px;
        }
        &__title {
            color: #334466;
            font-size: 16px;
            line-height: 25px;
            margin-bottom: 24px;
        }
        &__email {
            margin-bottom: 24px;
        }
        &__password {
            input {
                &:first-child {
                    margin-bottom: 20px;
                }
            }
        }
        input {
            height: 48px;
            border: 1px solid #D8DDE4;
            border-radius: 5px;
            padding: 8px 16px;
            width: 100%;
            font-size: 14px;
            line-height: 21px;
            &::placeholder {
                color: #878EA0;
            }
        }
        &__button {
            margin-bottom: 20px;
            background: linear-gradient(64.54deg, #6BBCBA 0%, #3BA5A1 100%);
            border: none;
            border-radius: 5px;
            font-size: 16px;
            line-height: 25px;
            color: #FCFCFC;
            padding: 8px 24px;
            text-align: center;
            margin-top: 24px;
            width: 100%;
            cursor: pointer;
        }
        &__controls {
            color: #878EA0;
            cursor: pointer;
            font-size: 14px;
            line-height: 21px;
        }
        &__input-block  {
            display: flex;
            justify-content: space-between;
            width: 100%;
            form {
                display: flex;
                justify-content: space-between;
                width: 100%;

            }
            input {
                border: 1px solid #D8DDE4;
                border-radius: 5px;
                height: 48px;
                width: 40px;
                padding: 8px 14px;
                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;

                }
                &[type=number] {

                }
            }
        }
        &__controls-additions {
            display: flex;
            >div {
                &:first-child {
                    margin-right: 34px;
                }
            }
        }
        &__addition {
            display: flex;
            align-items: center;
            .prev {
                height: 14px;
                margin-right: 10px;
            }
        }
    }
</style>
